module.exports = __webpack_public_path__ + "static/media/morning@2x.3d621f04.png";